import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Journals} from './journals';

@Injectable()
export class JournalsService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('journals?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('journals/logo').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('journals/' + _id).map((response: Response) => response.json());
    }


    getTrashedById(_id: string) {
        return this.http.get('journals/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('journals/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(invoice: Journals) {
        return this.http.post('journals', invoice).map((response: Response) => response.json());
    }

    update(invoice: Journals) {
        return this.http.put('journals/' + invoice.id, invoice).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('journals/' + _id);
    }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/journals/journals.service.ts